import { CUSTOM_FIELDS_VALUE_TYPE } from 'app/shared/components/customFields/CustomFieldsSection/CustomFieldsSection.constants';

import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';

export const CUSTOM_FIELDS_GROUP_KEY = 'customFields';

export const VALUE_TYPE_TO_FIELD_TYPE_MAP = {
  [CUSTOM_FIELDS_VALUE_TYPE.TEXT]: FieldType.INPUT,
  [CUSTOM_FIELDS_VALUE_TYPE.NUMBER]: FieldType.INPUT,
  [CUSTOM_FIELDS_VALUE_TYPE.DATE]: FieldType.DATE,
  [CUSTOM_FIELDS_VALUE_TYPE.BOOLEAN]: FieldType.CHECKBOX,
  [CUSTOM_FIELDS_VALUE_TYPE.PERCENTAGE]: FieldType.INPUT,
  [CUSTOM_FIELDS_VALUE_TYPE.CURRENCY]: FieldType.INPUT,
  [CUSTOM_FIELDS_VALUE_TYPE.EMAIL]: FieldType.INPUT,
  [CUSTOM_FIELDS_VALUE_TYPE.PHONE]: FieldType.INPUT,
  [CUSTOM_FIELDS_VALUE_TYPE.URL]: FieldType.INPUT,
};

export const VALUE_TYPE_TO_INPUT_TYPE_MAP = {
  [CUSTOM_FIELDS_VALUE_TYPE.NUMBER]: FieldInputType.FLOAT,
  [CUSTOM_FIELDS_VALUE_TYPE.PERCENTAGE]: FieldInputType.FLOAT,
  [CUSTOM_FIELDS_VALUE_TYPE.CURRENCY]: FieldInputType.CURRENCY,
  [CUSTOM_FIELDS_VALUE_TYPE.EMAIL]: FieldInputType.EMAIL,
  [CUSTOM_FIELDS_VALUE_TYPE.PHONE]: FieldInputType.TEL,
};

export const FORMAT_VALIDATED_VALUE_TYPES = [
  CUSTOM_FIELDS_VALUE_TYPE.EMAIL,
  CUSTOM_FIELDS_VALUE_TYPE.PHONE,
  CUSTOM_FIELDS_VALUE_TYPE.URL,
];
